/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const DateTimeClaimValue: core.serialization.ObjectSchema<
    serializers.DateTimeClaimValue.Raw,
    Truvity.DateTimeClaimValue
> = core.serialization.object({
    value: core.serialization.date(),
});

export declare namespace DateTimeClaimValue {
    export interface Raw {
        value: string;
    }
}
